/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Wide_Weasel_SparkInputs */

const fr_legal_wide_weasel_spark = /** @type {(inputs: Legal_Wide_Weasel_SparkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inscrits`)
};

/**

* @param {Legal_Wide_Weasel_SparkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const legal_wide_weasel_spark = /** @type {((inputs?: Legal_Wide_Weasel_SparkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Wide_Weasel_SparkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_legal_wide_weasel_spark(inputs)
});